import { nanoid } from 'nanoid';
import {
  createCorrectAnswer,
  createCorrectAnswers,
} from '../../plugins-common/CorrectAnswers/utils';
import { createParagraphToggle } from '../../plugins-common/ParagraphToggle/utils';
import { createQuestionStarter } from '../../plugins-common/QuestionStarter/transforms/createQuestionStarter';
import {
  ExerciseShortAnswerNode,
  EXERCISE_SHORT_ANSWER,
  EXERCISE_SHORT_ANSWER_BLANK,
  EXERCISE_SHORT_ANSWER_QUESTION,
  EXERCISE_SHORT_ANSWER_QUESTIONS,
  SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES,
} from './types';

export const createExerciseShortAnswer = (): ExerciseShortAnswerNode => {
  const id = nanoid();
  return {
    type: EXERCISE_SHORT_ANSWER,
    startFrom: 1,
    id,
    isLoginRequired: true,
    children: [
      createParagraphToggle({
        label: 'Guide',
        text: '',
        present: SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.GUIDE,
        placeholder: 'Điền hướng dẫn',
        parentNodeType: EXERCISE_SHORT_ANSWER,
      }),
      createQuestionStarter(EXERCISE_SHORT_ANSWER),
      {
        type: EXERCISE_SHORT_ANSWER_QUESTIONS,
        children: [createShortAnswerQuestion()],
      },
    ],
  };
};

export function createShortAnswerQuestion() {
  const id = nanoid();
  const blankId = nanoid();
  return {
    type: EXERCISE_SHORT_ANSWER_QUESTION,
    id,
    blankId,
    children: [
      createParagraphToggle({
        label: 'Question',
        text: '',
        present: SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.QUESTION,
        placeholder: 'Nhập câu hỏi _____',
        parentNodeType: EXERCISE_SHORT_ANSWER,
        toggle: false,
        includeVoids: false,
      }),
      createCorrectAnswers({
        label: 'Correct Answers',
        children: [createCorrectAnswer({ forId: blankId, showOrder: false })],
      }),
      createParagraphToggle({
        label: 'Explanation',
        text: '',
        toggle: false,
        present: SHORT_ANSWER_PARAGRAPH_TOGGLE_TYPES.EXPLANATION,
        placeholder: 'Điền giải thích',
        parentNodeType: EXERCISE_SHORT_ANSWER,
      }),
    ],
  };
}

export const createShortAnswerBlank = (id: string) => {
  return {
    type: EXERCISE_SHORT_ANSWER_BLANK,
    id,
    children: [{ text: '' }],
  };
};
